export enum MeasurementSystem {
  METRIC = 'Metric',
  US_CUSTOMARY = 'US Customary',
}

export function getWeightUnit(measurementSystem: MeasurementSystem) {
  return measurementSystem === MeasurementSystem.US_CUSTOMARY ? 'lb' : 'kg';
}

export function getHeightUnit(measurementSystem: MeasurementSystem) {
  return measurementSystem === MeasurementSystem.US_CUSTOMARY ? 'in' : 'cm';
}

export function getWeightUnitPlural(measurementSystem: MeasurementSystem) {
  return measurementSystem === MeasurementSystem.US_CUSTOMARY ? 'lbs' : 'kgs';
}

export function getHeightUnitPlural(measurementSystem: MeasurementSystem) {
  return measurementSystem === MeasurementSystem.US_CUSTOMARY ? 'ins' : 'cms';
}

export const inToCmConversionFactor = 2.54;
export const cmToInConversionFactor = 1 / 2.54;
export const lbToKgConversionFactor = 0.453592;
export const kgToLbConversionFactor = 1 / 0.453592;
